import React from 'react';
import { Clock, Users, Trophy, Utensils, Music, Heart } from 'lucide-react';
import { mockHotelData } from './mock';

const Programs = () => {
  const { programs } = mockHotelData;

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Fitness': return <Trophy className="text-orange-500" size={20} />;
      case 'Cultural': return <Utensils className="text-purple-500" size={20} />;
      case 'Entertainment': return <Music className="text-pink-500" size={20} />;
      case 'Kids': return <Heart className="text-red-500" size={20} />;
      case 'Sports': return <Trophy className="text-blue-500" size={20} />;
      case 'Culinary': return <Utensils className="text-green-500" size={20} />;
      default: return <Users className="text-gray-500" size={20} />;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'Fitness': return 'bg-orange-100 text-orange-800';
      case 'Cultural': return 'bg-purple-100 text-purple-800';
      case 'Entertainment': return 'bg-pink-100 text-pink-800';
      case 'Kids': return 'bg-red-100 text-red-800';
      case 'Sports': return 'bg-blue-100 text-blue-800';
      case 'Culinary': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <section id="programs" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            {programs.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From morning activities to evening entertainment, there was something for everyone in our family
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Programs Image */}
          <div className="relative">
            <img
              src={programs.programImage}
              alt="Hotel programs and activities"
              className="w-full h-96 object-cover rounded-2xl shadow-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>

          {/* Activities Grid */}
          <div className="grid gap-4">
            {programs.activities.map((activity, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-200 hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div className="mt-1">
                    {getCategoryIcon(activity.category)}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="text-lg font-bold text-gray-800">{activity.name}</h3>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCategoryColor(activity.category)}`}>
                        {activity.category}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 mb-3">
                      <Clock className="text-gray-400" size={16} />
                      <span className="text-sm text-gray-600">{activity.time}</span>
                    </div>
                    <p className="text-gray-600 text-sm">{activity.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Hotel Amenities */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-3xl font-bold text-gray-800 mb-8 text-center">Hotel Amenities</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {programs.amenities.map((amenity, index) => (
              <div
                key={index}
                className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              >
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <span className="text-gray-700 font-medium">{amenity}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Programs;